
import {Component, Vue} from 'vue-property-decorator';

@Component({name: 'ModuleLayoutTest'})
export default class ModuleLayoutTest extends Vue {
    /** 返回资源管理，测试入口不调用任何业务更新接口。 */
    backToResources() { this.$router.push('/sys/SourceManage'); }
}
